// NUM_MONTHS is the number of months to query while making reservation
// enquiries for the calendar
export const NUM_MONTHS = 2;
